export const AppConstant = {
    BASE_URL: "https://j3vx8pdbue.execute-api.eu-central-1.amazonaws.com/prod/api",
    IMAGE_BASE_URL: "https://d77ud043co8mq.cloudfront.net/",

    // BASE_URL: "https://dnvwoq0s9i.execute-api.us-east-1.amazonaws.com/dev/api",//Logicraft Dev Server 
    // IMAGE_BASE_URL: "https://d2dtzaclrhx2m9.cloudfront.net/",//Logicraft Dev Server 
    // BASE_URL: "http://localhost:5009/api",
    // IMAGE_BASE_URL: "http://localhost:5009/",
    GOOGLE_API_KEY : "AIzaSyAMG4NBZMWBZW9iey31m6kvDJIlKq8_RIE",
    authToken: "authToken",
    isAuthenticated: "isAuthenticated",
    loginName: "loginName",
    loginId: "loginId",
    currencySymbol: "₺",
}